import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue";
import { onBeforeRouteLeave } from "vue-router";
import { TransferOffer } from "@/modules/transfer-market/entity";
import TransferOfferSlim from "@/modules/transfer-market/components/TransferOfferSlim.vue";
import PlayerLayout from "@/modules/team/pages/players/PlayerLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Offers',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const offers = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      const playerId = route.params.id;
      offers.value = await TransferOffer.createQueryBuilder('offer').innerJoinAndSelect('offer.player', 'player').innerJoinAndSelect('player.country', 'playerCountry').innerJoinAndSelect('offer.playersTeam', 'playersTeam').innerJoinAndSelect('offer.team', 'team').innerJoinAndSelect('team.country', 'country').where('player.id = :playerId', {
        playerId
      }).orderBy('offer.id', "DESC").getMany();
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      return _openBlock(), _createBlock(PlayerLayout, {
        onUpdated: _unref(refresh)
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [offers.value.length === 0 ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0,
          description: _ctx.$t('no_offers_yet')
        }, null, 8, ["description"])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(offers.value, offer => {
          return _openBlock(), _createBlock(TransferOfferSlim, {
            key: offer.id,
            offer: offer
          }, null, 8, ["offer"]);
        }), 128))])]),
        _: 1
      }, 8, ["onUpdated"]);
    };
  }
});